/**
 * Time periods are objects with start and end times. This is used in areas of the app where we want to query or filter
 * between certain dates, i.e. time periods. For example, the time period for "THIS_WEEK" has a `start` of the beginning of this current
 * week and an `end` of the end of the week.
 */

import moment from 'moment';

// TODO: do we want to move dayFormat and timeFormat to the constants file?
const dayFormat = 'YYYY-MM-DDT00:00:00Z';
const timeFormat = 'YYYY-MM-DDTHH:mm:ssZ';
const thisYear = new Date().getFullYear();

const startToday = moment().startOf('day').format(timeFormat);
const endToday = moment().endOf('day').format(timeFormat);
const today = moment().format(dayFormat);
const startYday = moment().subtract(1, 'days').startOf('day').format(timeFormat);
const endYday = moment().subtract(1, 'days').endOf('day').format(timeFormat);
const yesterday = moment().subtract(1, 'days').format(dayFormat);
const beginOfWeek = moment().startOf('week').format(timeFormat);
const endOfWeek = moment().endOf('week').format(timeFormat);
const beginOfLastWeek = moment().subtract(7, 'days').startOf('week').format(timeFormat);
const endOfLastWeek = moment().subtract(7, 'days').endOf('week').format(timeFormat);
const beginOfMonth = moment().startOf('month').format(timeFormat);
const endOfMonth = moment().endOf('month').format(timeFormat);
const beginOfLastMonth = moment().subtract(1, 'month').startOf('month').format(timeFormat);
const endOfLastMonth = moment().subtract(1, 'month').endOf('month').format(timeFormat);
const thirtyDaysAgo = moment().subtract(29, 'days').format(dayFormat);
const sixtyDaysAgo = moment().subtract(59, 'days').format(dayFormat);
const ninetyDaysAgo = moment().subtract(89, 'days').format(dayFormat);
const beginOfQuarter = moment().startOf('quarter').format(dayFormat);
const previousQuarter = moment().subtract(1, 'quarter').startOf('quarter').format(dayFormat);
const endOfPreviousQuarter = moment().subtract(1, 'Q').endOf('quarter').format(dayFormat);
const twelveMonthsAgo = moment().subtract(12, 'months').format(dayFormat);
const yearStart = moment().startOf('year').format(dayFormat);
const lastYearStart = moment().subtract(1, 'years').startOf('year').format(timeFormat);
const lastYearEnd = moment().subtract(1, 'years').endOf('year').format(timeFormat);
const last2YearStart = moment().subtract(2, 'years').startOf('year').format(timeFormat);
const last2YearEnd = moment().subtract(2, 'years').endOf('year').format(timeFormat);
const tomorrow = moment().add(1, 'days').endOf('day').format(timeFormat);
const endOfNextWeek = moment().add(7, 'days').endOf('week').format(timeFormat);
const endOfTwoWeek = moment().add(14, 'days').endOf('week').format(timeFormat);
const oneYearAgo = moment().subtract(365, 'days').format(timeFormat);
const thirtySixMonthsAgo = moment().subtract(36, 'months').format(timeFormat);
const sixtyMonthsAgo = moment().subtract(60, 'months').format(timeFormat);
const sevenDaysOut = moment().add(7, 'days').format(timeFormat);
const pastTwoDays = moment().subtract(2, 'days').format(timeFormat);
const futureFiveDays = moment().add(5, 'days').format(timeFormat);
const futureOneYear = moment().add(1, 'years').format(timeFormat);
const pastThreeDays = moment().subtract(3, 'days').format(timeFormat);
const fifteenDaysOut = moment().add(15, 'days').endOf('day').format(dayFormat);
const twentyDaysOut = moment().add(20, 'days').endOf('day').format(dayFormat);
const thirtyDaysOut = moment().add(30, 'days').endOf('day').format(dayFormat);
const fourtyFiveDaysOut = moment().add(45, 'days').endOf('day').format(dayFormat);
const sixtyDaysOut = moment().add(60, 'days').endOf('day').format(dayFormat);

const applyAll = {kpi: true, list: true};
const applyLeader = {kpi: true, list: false};
const applyList = {kpi: false, list: true};
const applyNone = {kpi: false, list: false};

export const timePeriods = [
    {label: 'Today', value: 'TODAY', start: startToday, end: endToday, filter: applyAll}, //0
    {label: 'Yesterday', value: 'YESTERDAY', start: startYday, end: endYday, filter: applyAll}, //1
    {label: 'This Week', value: 'THIS_WEEK', start: beginOfWeek, end: endOfWeek, filter: applyAll}, //2
    {label: 'Last Week', value: 'LAST_WEEK', start: beginOfLastWeek, end: endOfLastWeek, filter: applyAll}, //3
    {label: 'This Month', value: 'THIS_MONTH', start: beginOfMonth, end: endOfMonth, filter: applyAll}, //4
    {label: 'Last Month', value: 'LAST_MONTH', start: beginOfLastMonth, end: endOfLastMonth, filter: applyAll}, //5
    {label: 'Last 30 Days', value: 'LAST_30_DAYS', start: thirtyDaysAgo, end: endToday, filter: applyAll}, //6
    {label: 'Last 60 Days', value: 'LAST_60_DAYS', start: sixtyDaysAgo, end: endToday, filter: applyAll}, //7
    {label: 'Last 90 Days', value: 'LAST_90_DAYS', start: ninetyDaysAgo, end: endToday, filter: applyAll}, //8
    {label: 'This Quarter', value: 'THIS_QUARTER', start: beginOfQuarter, end: endToday, filter: applyAll}, //9
    {label: 'One Year', value: 'LAST_12_MONTHS', start: twelveMonthsAgo, end: endToday, filter: applyList}, //10
    {label: String(thisYear - 1), value: 'LAST_YEAR', start: lastYearStart, end: lastYearEnd, filter: applyList}, //11
    {label: String(thisYear - 2), value: 'LAST_2_YEARS', start: last2YearStart, end: last2YearEnd, filter: applyList}, //12
    {label: 'Last 3 Years', value: 'LAST_36_MONTHS', start: thirtySixMonthsAgo, end: endToday, filter: applyList}, //13
    {label: 'Last 5 Years', value: 'LAST_60_MONTHS', start: sixtyMonthsAgo, end: endToday, filter: applyList}, //14
];

export const fieldKpiTimeperiods = [
    {label: 'This Week', value: 'THIS_WEEK', start: beginOfWeek, end: endOfWeek, filter: applyAll}, //0
    {label: 'Last Week', value: 'LAST_WEEK', start: beginOfLastWeek, end: endOfLastWeek, filter: applyAll}, //1
    {label: 'This Month', value: 'THIS_MONTH', start: beginOfMonth, end: endOfMonth, filter: applyAll}, //2
    {label: 'Last Month', value: 'LAST_MONTH', start: beginOfLastMonth, end: endOfLastMonth, filter: applyAll}, //3
];

export const scoreboardTimePeriods = [
    {label: 'Previous Quarter', value: 'PREVIOUS_QUARTER', start: previousQuarter, end: endOfPreviousQuarter, filter: applyAll}, //0
    {label: 'Year To Date', value: 'YEAR_TO_DATE', start: yearStart, end: endToday, filter: applyAll}, //1
];

export const surveyTimePeriods = [
    {label: 'Two Weeks', value: 'Two_Weeks', start: beginOfLastWeek, end: endOfNextWeek, filter: applyAll}, //0
    {label: 'Three Weeks', value: 'Three_Weeks', start: beginOfLastWeek, end: endOfTwoWeek, filter: applyAll} //1
];

export const kpiThisYear = [
    {label: 'This Year', value: 'THIS_YEAR', start: yearStart, end: endToday, filter: applyAll}, //0
    {label: 'Last Year', value: 'LAST_YEAR', start: lastYearStart, end: lastYearEnd, filter: applyList}, //1
];

export const installTimePeriods = [
    {label: 'Month Out', value: 'Month_Out', start: thirtyDaysOut, end: sixtyDaysOut, filter: applyAll}, //0
    {label: 'Fourty Five Out', value: 'Fourty_Five_Out', start: fourtyFiveDaysOut, end: sixtyDaysOut, filter: applyAll}, //1
    {label: 'Twenty Out', value: 'Twenty_Out', start: twentyDaysOut, end: sixtyDaysOut, filter: applyAll}, //2
    {label: 'Fifteen Out', value: 'Fifteen_Out', start: fifteenDaysOut, end: sixtyDaysOut, filter: applyAll}, //3
    {label: 'Two Months', value: 'Two_Months', start: today, end: sixtyDaysOut, filter: applyAll}, //4
];

export const fieldCustomersTimePeriods = [
    {label: 'Future', value: 'Future', start: startToday, end: futureOneYear, filter: applyAll},
    ...timePeriods
]

let kpiTimePeriods = [...timePeriods].slice(0, 10);
kpiTimePeriods.push(scoreboardTimePeriods[0]);
kpiTimePeriods.push(kpiThisYear[0]);
kpiTimePeriods.push(kpiThisYear[1]);

export const timePeriodsThisQuarter = kpiTimePeriods; // time periods for this quarter and earlier
export const DEFAULT_SELECTED_TIME_PERIOD = timePeriods[6];
export const TIME_PERIOD_TODAY = timePeriods[0];
export const TIME_PERIOD_THIS_WEEK = timePeriods[2];
export const TIME_PERIOD_LAST_MONTH = timePeriods[5];
export const SCHEDULABLE_QUERY_TIME_PERIOD = {label: 'Schedulable Query', value: 'SCHEDULABLE', start: pastThreeDays, end: futureFiveDays, filter: applyNone}; //14
export const THIS_QUARTER = timePeriods[9];
export const PREVIOUS_QUARTER = scoreboardTimePeriods[0];
export const YEAR_TO_DATE = scoreboardTimePeriods[1];
export const Two_Weeks = surveyTimePeriods[0];
export const Three_Weeks = surveyTimePeriods[1];
export const futureSurvey = {label: 'Future Survey Query', value: 'SCHEDULABLE', start: endToday, end: endOfTwoWeek, filter: applyNone};
export const Month_Out = installTimePeriods[0];
export const Fourty_Five_Out = installTimePeriods[1];
export const Twenty_Out = installTimePeriods[2];
export const Fifteen_Out = installTimePeriods[3];
export const Two_Months = installTimePeriods[4];


// N.b. this entry is not used anywhere, but existed in an older (Angular) front-end implementation:
// {label: 'Field Queue', value: 'QUEUE', start: startToday, end: tomorrow, filter: applyNone} //15
